import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { pathOr, clone } from "ramda";

import { toast } from "react-toastify";
import { EmailForm } from '../';




import {submitEmailCreateView } from '../../../../store/actions/emails.actions';


const QuickComposeEmail = ({subject="",body="",to_addrs_names,cc_addrs_names,bcc_addrs_names, handleClose, parent_name = [], modalState }) => {
	
	const dispatch = useDispatch();
	const { id } = useParams();
	
	const [initialValues, setInitialValues] = useState([]);
	const [attachedFiles, setAttachedFiles] = useState([]);
	const [attachedDocuments, setAttachedDocuments] = useState([]);
	const { emailCreateViewLoading, emailCreateViewError, emailCreateViewTabData, emailSubmitLoader } = useSelector((state) => state.emails);
	const [data, setData] = useState(pathOr([], ['data', 'templateMeta', 'data'], emailCreateViewTabData['Emails']));
	let getAttachemnt = pathOr(null, ['data', 'templateMeta', 'attachment'], emailCreateViewTabData['Emails']);
	const [attachment, setAttachment] = useState(getAttachemnt && getAttachemnt.fileid ? [{ value: getAttachemnt.filename, email: '', id: getAttachemnt.fileid }] : []);
	const [fromFields, setFromFields] = useState(pathOr([], ['data', 'templateMeta', 'fromFields'], emailCreateViewTabData['Emails']))
	useEffect(
		() => {
			// {
			data.length && data[0].attributes.map((row) => {
				row.map((col) => {
					if (col.name === 'from_addr_name' && fromFields) {
						initialValues['from_addr'] = '';
						initialValues['inbound_email_id'] = '';

					} else {
						initialValues[col.name] = col.value || '';
					}
				});
			});
			for (var i = 0; i < 10; i++) {
				initialValues['documentId' + i] = '';
			}
			if (attachment[0]) {
				let prevFiles = clone(attachedDocuments);
				prevFiles.push(attachment[0]);
				setAttachedDocuments(prevFiles);
			}
			initialValues['name'] = subject || "";
			initialValues['to_addrs_names'] = to_addrs_names?to_addrs_names:'';
			initialValues['cc_addrs_names'] = cc_addrs_names?cc_addrs_names:'';
			initialValues['bcc_addrs_names'] = bcc_addrs_names?bcc_addrs_names:'';
			initialValues['email_attachment'] = [];
			initialValues['emails_email_templates_name'] = '';
			initialValues['emails_email_templates_idb'] = '';
			initialValues['parent'] = parent_name || { 'parent_name': '', 'parent_type': '', 'parent_id': '' };
			initialValues['parent_type'] = parent_name.parent_type || '';
			initialValues['parent_name'] = parent_name.parent_name || '';
			initialValues['parent_id'] = parent_name.parent_id || '';
			initialValues['type'] = 'out';
			initialValues['send'] = "1";
			initialValues['refer_action'] = "ComposeView";
			initialValues['description'] = initialValues['description'] || initialValues['description_html'];
			initialValues['description'] = body || initialValues['description'];
			initialValues['dummy_attachment'] = attachment[0] ? [attachment[0].id] || [] : [];
			setInitialValues({ ...initialValues, initialValues })
		},
		[data]
	);

	useEffect(() => {
		attachedDocuments.length && attachedDocuments.map((document, docNo) => {
			initialValues['documentId' + docNo] = document.id || '';
		})
	}, [attachedDocuments])
	useEffect(() => {

		let allFiles = [];
		attachedFiles.map((file) => {
			getBase64(file).then(
				data => allFiles.push(data)
			)
		})
		initialValues['email_attachment'] = allFiles;
		// setInitialValues({ ...initialValues, email_attachment: allFiles });
		// console.log("attachedFiles", attachedFiles, initialValues)
	}, [attachedFiles])

	const getBase64 = (file, cb) => {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			// reader.onload = () => resolve({ 'file_name': file.name, 'file_content': reader.result.replace(/^data:.+;base64,/, '') });
			reader.onload = () => resolve({ 'file_name': file.name, 'file_content': reader.result });
			reader.onerror = error => reject(error);
		});
	}
	if (emailCreateViewLoading) {
		// return <p>Loading...</p>;
	}
	if (emailCreateViewError) {
		return <h3>{emailCreateViewError && ''}</h3>;
	}
	// console.log("initialValues", initialValues)
	const onChange = (field, val) => {
		switch (field) {
			case ('from_addr_name'):
				setInitialValues({ ...initialValues, inbound_email_id: val, ["from_addr"]: data[0].attributes[1][0].options[val] });
				break;

			case ('emails_email_templates_name'):

				setInitialValues({ ...initialValues, description: val.email_template, emails_email_templates_name: val.value, emails_email_templates_idb: val.id,name:val.value });
				break;

			case ("parent_name"):
				setInitialValues({ ...initialValues, parent: val, parent_id: val.parent_id, parent_name: val.parent_name, parent_type: val.parent_type });
				break;
			default:
				setInitialValues({ ...initialValues, [field]: val });
				break;
		}
	}
	const onSubmit = () => {
		var params = JSON.stringify({ attribute: initialValues });
		try {
			dispatch(submitEmailCreateView(params, id)).then(function (res) {
				if (res && res.ok) {
					handleClose();
					toast(pathOr("Success! Email sent.",["data","data","discription"],res));

				} else {
					toast(pathOr("Failed! Email was not sent.",["data","data","discription"],res));
				}
			});
		} catch (e) {
			toast('Something went wrong!');
		}
	};
	return (
		<>
			{!emailCreateViewLoading && data.length ? (<EmailForm modalState={modalState} handleSubmit={onSubmit} emailSubmitLoader={emailSubmitLoader} handleClose={handleClose} onChange={onChange} metaData={data} initialValues={initialValues} setInitialValues={setInitialValues} attachedFiles={attachedFiles} setAttachedFiles={setAttachedFiles} attachedDocuments={attachedDocuments} setAttachedDocuments={setAttachedDocuments} />) : ""}
		</>
	);
};

export default QuickComposeEmail;
